function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 18.5,
  r: 9.5,
  fill: "#A4E7DB"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 19.41l4.17 4.17L26.76 13",
  stroke: "#073331",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 1.051L33 6.064v13.622c0 6.043-3.713 11.494-9.519 13.837l-5.981 2.4-5.981-2.4s0 0 0 0C5.712 31.18 2 25.729 2 19.686V6.064l15.5-5.013z",
  stroke: "#073331",
  strokeWidth: 2
});

function SvgGuaranteeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgGuaranteeIcon;